<template>
    <div class="flex items-center justify-between" style="width: 100%;">
        <div v-if="!userInfo.need_azn_cash" class="text-sm font-medium" style="width: 100%;">
            {{ item.quantity }}&nbsp;<small>x</small>&nbsp;${{ item.Amount }} <template v-if="item.provider_id == 3"><template v-if="item.days !== ''"> ({{ item.days }})</template></template>
            <feather-icon icon="XIcon" @click.stop="removeItemFromBasket(1, quantity)" svgClasses="h-4 w-4 cursor-pointer text-danger" class="hover:text-danger float-right" style="margin-top: 1px;" />
            <input v-if="item.provider_id != 3" type="number" :value="quantity" v-on:keyup="changeQuantity" class="vs-input-number--input float-right" ref="quantity">
        </div>
        <div v-else class="text-sm font-medium" style="width: 100%;">
            <div v-if="item.cash_quantity > 0">
                {{ $t('cash') }}:&nbsp;{{ item.cash_quantity }}&nbsp;<small>x</small>&nbsp;{{ item.cash_amount }}&nbsp;AZN
                <feather-icon icon="XIcon" @click.stop="removeItemFromBasket(1, cash_quantity)" svgClasses="h-4 w-4 cursor-pointer text-danger" class="hover:text-danger float-right" style="margin-top: 1px;" />
                <input type="number" :value="cash_quantity" v-on:keyup="changeCashQuantity" class="vs-input-number--input float-right" ref="cash_quantity">
            </div>
            <div v-if="item.credit_quantity > 0">
                {{ $t('credit') }}:&nbsp;{{ item.credit_quantity }}&nbsp;<small>x</small>&nbsp;{{ item.credit_amount }}&nbsp;AZN
                <feather-icon icon="XIcon" @click.stop="removeItemFromBasket(2, credit_quantity)" svgClasses="h-4 w-4 cursor-pointer text-danger" class="hover:text-danger float-right" style="margin-top: 1px;" />
                <input type="number" :value="credit_quantity" v-on:keyup="changeCreditQuantity" class="vs-input-number--input float-right" ref="credit_quantity">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            item: {
                type: Object,
                required: true
            },
        },
        components: {

        },
        data() {
            return {
                userInfo: window.userInfo,
                quantity: 1,
                credit_quantity: 1,
                cash_quantity: 1,
            }
        },
        computed: {

        },
        created() {

        },
        methods: {
            changeQuantity(event){
                this.quantity = this.changeQuantityBase(event);
                this.$refs.quantity.value = this.quantity;
            },
            changeCreditQuantity(event){
                this.credit_quantity = this.changeQuantityBase(event);
                this.$refs.credit_quantity.value = this.credit_quantity;
            },
            changeCashQuantity(event){
                this.cash_quantity = this.changeQuantityBase(event);
                this.$refs.cash_quantity.value = this.cash_quantity;
            },
            changeQuantityBase(event){
                let value = event.target.value;
                value = parseInt(value.replace(/[^0-9]/g, ''));

                if (Number.isNaN(value)) value = 1;
                if (!Number.isInteger(value)) value = 1;
                if (value < 1) value = 1;

                return value
            },
            removeItemFromBasket(sell_type = 1, count) { /* WORK */
                let thisIns = this;
                this.$vs.loading();

                let productId = this.item.id;
                let url = apiUrl+'/basket/removeMass/'+productId+'/'+sell_type+'/'+count+'?token='+window.token
                if (this.item.provider_id == 3){
                    count = this.item.quantity;
                    url += '&adobe_customer_user_id='+this.item.additional_data.adobe.customer_user_id;
                }

                axios.get(url)
                    .then(function (response) {
                        let data = response.data;
                        if(data.code === 200){
                            thisIns.$store.dispatch('basket/reloadData', data.data);
                        }
                        else if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.loading.close();
                    });
            },
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    /* Chrome, Safari, Edge, Opera */
    input[type=number]::-webkit-outer-spin-button,
    input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance:textfield;
        width: 30px;
    }
</style>
